'use strict';

var Stringify = require('./stringify');
var Parse = require('./parse');

module.exports = {
    stringify: Stringify,
    parse: Parse
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/qs/lib/index.js
 ** module id = 18
 ** module chunks = 2 3 6 7 9 10 11 12 13 14 15 16 18 19 20 21 22 24 25 26
 **/